var map = {
	"./1.png": "A1tS",
	"./2.png": "chPc",
	"./3.png": "ZK0V",
	"./4.png": "q/uz",
	"./5.png": "PgLh",
	"./5stars.png": "za8G",
	"./6.png": "0DhX",
	"./7.png": "DBM3",
	"./Deslike.svg": "Zigp",
	"./Like.svg": "/6Q0",
	"./NPS.png": "UYZt",
	"./_1.png": "Ysz+",
	"./_2.png": "GT67",
	"./_3.png": "WdtV",
	"./_4.png": "cFX2",
	"./_5.png": "q/bm",
	"./_6.png": "vzYR",
	"./_7.png": "4VrU",
	"./_8.png": "q+99",
	"./addquestion-ces.png": "Zxyf",
	"./addquestion-likert.png": "Aii+",
	"./addquestion-nps.png": "SqGv",
	"./airplane-background.jpg": "1wu/",
	"./analise-dispositivo.png": "AmA8",
	"./analise-indicador.png": "zC+q",
	"./analise-sentimento-1.png": "/86C",
	"./analise-sentimento-2.png": "qLaV",
	"./analise-sentimento-3.png": "/TeS",
	"./analise-sentimento-4.png": "Ayxt",
	"./analise-sentimento-5.png": "OA/F",
	"./background-boticario.jpeg": "CMD9",
	"./background00-mercedes-2023.jpg": "X7hC",
	"./background01-mercedes-2023.jpg": "C9Gq",
	"./background02-mercedes-2023.jpg": "MemM",
	"./buildings-background.jpg": "l6vF",
	"./categorias.png": "0/UF",
	"./ces.png": "ga/r",
	"./cgone-logo.png": "EqB5",
	"./classificacao-sentimento-grafico.png": "AHQs",
	"./classificacao-sentimento.png": "G/we",
	"./coin-background.jpg": "Lv54",
	"./comparativo-ações.png": "I0uj",
	"./computer-background.jpg": "fWHF",
	"./conversao.png": "2UmB",
	"./csat.png": "3lmb",
	"./desk-background.jpg": "Oiyl",
	"./deslike-gray.svg": "OtBC",
	"./detratores-recorrentes.png": "OhT1",
	"./distribuicao-notas.png": "7yhD",
	"./emotion.png": "MODb",
	"./error-research.png": "bWiV",
	"./escala0a10-csat.png": "1I7m",
	"./evolucao-convites-area.png": "JJPk",
	"./evolucao-convites-bar.png": "I9tZ",
	"./evolucao-convites-line.png": "XCS4",
	"./evolucao-like-dislike-area.png": "TlXe",
	"./evolucao-like-dislike-barra.png": "2/Ux",
	"./evolucao-like-dislike-linha.png": "LIr+",
	"./evolucao-respostas-area.png": "zEdS",
	"./evolucao-respostas-barra.png": "D4n+",
	"./evolucao-respostas-linha.png": "yqPF",
	"./evolucao-sentimento-area.png": "CgRw",
	"./evolucao-sentimento-barras.png": "ZrEt",
	"./evolucao-sentimento-linhas.png": "WbGC",
	"./evolução-ações.png": "okcp",
	"./evolução-convites.png": "C0g1",
	"./evolução-nps-area.png": "baLN",
	"./evolução-nps-linha.png": "S0Zp",
	"./evolução-nps.png": "7mBm",
	"./evolução-percentuais.png": "C3OZ",
	"./face-angry-solid.svg": "ltl+",
	"./face-frown-solid.svg": "he1t",
	"./face-grin-solid.svg": "EU50",
	"./face-meh-solid.svg": "67/t",
	"./face-smile-solid.svg": "IaC6",
	"./fake-chart-map.png": "x7M7",
	"./grandfather-background.jpg": "1Od+",
	"./img-final-research.png": "j4+U",
	"./indicador-sentimento.png": "gsxB",
	"./indice.png": "74IR",
	"./info-nps.png": "55sI",
	"./keywords-chart.png": "0slV",
	"./like-dislike-panel.png": "65Lw",
	"./like-dislike.png": "spS4",
	"./like-gray.svg": "dJKP",
	"./likert.png": "rYNN",
	"./logo-embracon.svg": "g9V5",
	"./logo-enjoei.png": "3rR3",
	"./logo-getnet.png": "FoDV",
	"./logo-indecx-positiva.png": "HNue",
	"./logo-indecx.png": "b/B2",
	"./logo-junto-seguros.jpeg": "8OYP",
	"./logo-junto.png": "J5C0",
	"./logo-ltm.png": "livD",
	"./logo-mrv.png": "iyap",
	"./logo-natal.png": "7zAy",
	"./logo-pwc.png": "kz1B",
	"./logo-pwc.svg": "2XYk",
	"./logo-sinqia.png": "kIVF",
	"./logo-tenda.png": "Suq5",
	"./logo-tribanco.png": "V92C",
	"./logo-unicred.png": "Z+I3",
	"./logo.png": "7Otq",
	"./logoIndecx.png": "/tlN",
	"./logo_indecx.png": "+IaN",
	"./make-panel.jpg": "hdCd",
	"./mobile.png": "dft9",
	"./modal-nps-en.png": "11WA",
	"./modal-nps-es.png": "//0m",
	"./monitoramento-pesquisa.png": "lzzP",
	"./multipla-escolha.png": "vNRU",
	"./negative.gif": "NK4y",
	"./neutral.gif": "SnIB",
	"./nuvem-palavras.png": "bjKa",
	"./percentual.png": "ZjRK",
	"./pergunta-adicional.png": "mKkH",
	"./pergunta-canais.png": "ygFY",
	"./pergunta-por-canais.png": "Gp25",
	"./polygon-left.png": "1+/G",
	"./polygon-right.png": "U4CO",
	"./positive.gif": "xvK7",
	"./ranking-pergunta-adicional.png": "7BXu",
	"./relatorio-mapa.png": "IAcT",
	"./review.png": "wm26",
	"./robot-2-line-active.svg": "mlf0",
	"./robot-2-line-default.svg": "77vW",
	"./score-sentimento.png": "twWc",
	"./sort-bigger.png": "MYVU",
	"./sort-default.png": "zOHx",
	"./sort-smallest.png": "QukL",
	"./status-tratativas.png": "TSS4",
	"./street-background.jpg": "ym7o",
	"./summarization.png": "byLn",
	"./swot.png": "KyKe",
	"./tags-tratativas.png": "wm9W",
	"./top5-keywords.png": "Rk+c",
	"./translate.png": "x2DF",
	"./use-template.jpg": "PzPN",
	"./wallpaper-mb1.jpg": "Wpyj",
	"./wallpaper-mb2.jpg": "XZER",
	"./wallpaper-mb3.jpg": "iBCh",
	"./wallpaper-mb4.jpg": "ZRa+",
	"./wallpaper-mb5.jpg": "1+zK",
	"./wallpaper-mb6.jpg": "jpcW",
	"./widget-bar.png": "5G43",
	"./widget-box.png": "5X1h",
	"./widget-modal.png": "98tf",
	"./woman-background.jpg": "11UF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1